import { Fields as MerchantFields } from 'models/Merchant'

/**
 * True when ANY of the merchant's redemption providers has a `value` in the
 * given set. `value` is a `Pos::Provider#value` as served by the merchant API
 * in `merchant.all_redemption_providers[].value` (nucleus `pos_providers`
 * table) — there is no backend equivalent for grouping these into named
 * sets, so callers define their own POS-value sets as the source of truth.
 */
export const matchesAnyProvider = (
  merchant: MerchantFields | null | undefined,
  providerValues: Set<string>
): boolean =>
  (merchant?.all_redemption_providers ?? []).some(provider =>
    providerValues.has(provider.value)
  )
